module.exports = __webpack_public_path__ + "img/logo1.864ef490.png";